import { createFeatureSelector, createSelector } from "@ngrx/store";
import { TreatmentTypeState } from "./treatment-type.state";

const selectTreatmentTypefeatureState = createFeatureSelector<TreatmentTypeState>('treatmentTypeStore')

export const selectTreatmentTypes = createSelector(
    selectTreatmentTypefeatureState,
    state => state.treatmentTypes 
)

export const selectTreatmentTypeStateEvent = createSelector(
    selectTreatmentTypefeatureState,
    state => state.treatmentTypeStateEvent
)

export const selectTreatmentType = createSelector(
    selectTreatmentTypefeatureState,
    state => state.selectedTreatmentType
) 